import { Injectable } from '@angular/core';
import { environment } from 'projects/visa-platform/src/environments/environment';
import {
  Language,
  StaticTextContents,
} from 'projects/visa-platform/src/environments/environment.interface';
import { languageSpecificConfigs as en } from 'projects/visa-platform/src/environments/ssa/en';
import { languageSpecificConfigs as fr } from 'projects/visa-platform/src/environments/ssa/fr';
import { languageSpecificConfigs as pt } from 'projects/visa-platform/src/environments/ssa/pt';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  private currentLanguage: Language = environment.languages?.[0] ?? {
    code: 'en',
    label: 'English',
    id: 'e2148d59-b1b6-4f82-8fe6-179b6714db01',
  };
  private allTextContents: Record<string, StaticTextContents> = {
    en,
    fr,
    pt,
  };

  private languageChanged = new BehaviorSubject<string>(
    this.currentLanguage.code
  );
  public languageChanged$ = this.languageChanged.asObservable();

  public constructor() {
    this.getLanguageFromStorage();
    this.languageChanged.next(this.currentLanguage.code);
  }

  public get currentLang(): string {
    this.getLanguageFromStorage();
    return this.currentLanguage.code;
  }

  public setCurrLang(lang: Language): void {
    localStorage.setItem('language-selected', JSON.stringify(lang));
    this.currentLanguage = lang;
    this.languageChanged.next(lang.code);
  }

  private getLanguageFromStorage(): void {
    const langDetails = JSON.parse(
      localStorage.getItem('language-selected') || '{"code":"en","id":""}'
    );
    this.currentLanguage = langDetails;
  }

  public setLanguageTexts(): void {
    this.getLanguageFromStorage();
    environment.staticTextContents =
      this.allTextContents[this.currentLanguage.code] ||
      this.allTextContents['en'];
    this.languageChanged.next(this.currentLanguage.code);
  }
}

/*
COMMENT - Steps to add a new language
1. Create a new file and have all the language specific texts
2. Add the new language code in the allTextContents object
3. Add the new language id in the environment files
*/
